import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LeadCaptureDialog from '@components/modals/LeadCaptureDialog/LeadCaptureDialog';
import { LeadCaptureReason } from '@t/serviceQualification.types';
import { ROUTES } from '@constants/routes';
import { useQualificationFlowStore } from '@store/qualificationStore/qualificationStore';

interface LeadCaptureProps {
  onClose: () => void;
}

const LeadCapture = ({ onClose }: LeadCaptureProps) => {
  const navigate = useNavigate();
  const setQualificationFlow = useQualificationFlowStore((s) => s.setQualificationFlow);

  // Business entry: seed the qualification store so the dialog shows the
  // business message + radio and fires lead_started with the BUSINESS reason.
  useState(() => {
    setQualificationFlow((prev) => ({
      ...prev,
      customerType: 'BUSINESS',
      leadCaptureReason: LeadCaptureReason.BUSINESS,
    }));
  });

  return (
    <LeadCaptureDialog
      open
      onClose={() => {
        navigate(ROUTES.RESIDENTIAL);
      }}
      onSuccess={() => {
        onClose();
      }}
    />
  );
};

export default LeadCapture;
